import { Type } from "@sinclair/typebox";
import { MaintenanceState } from "../enums";
/**
 * The maintenance banner's payload, broadcast on change and sent on connect.
 *
 * `until` is an **absolute instant**, never a remaining duration — the same
 * rule phase deadlines follow. Clients count down against it locally, so a
 * backgrounded tab cannot drift and the server sends nothing per second.
 * It is null when the state is `Off`, or once `Active` has been reached and
 * there is nothing left to count towards.
 */
export const MaintenancePayloadSchema = Type.Object({
    state: Type.Enum(MaintenanceState),
    until: Type.Union([Type.String(), Type.Null()]),
});
/**
 * Admin request to change it. `countdown_minutes` is set per flip rather than
 * fixed, so a busy night can be given a longer warning than a quiet one. It is
 * required for `Draining` and ignored otherwise.
 */
export const MaintenanceSetReqSchema = Type.Object({
    state: Type.Enum(MaintenanceState),
    countdown_minutes: Type.Union([Type.Integer({ minimum: 1, maximum: 120 }), Type.Null()]),
});
/**
 * Live counts are **derived by counting Redis records**, never read from a
 * stored counter — plan.md §1.10 is explicit, because a crash or an expiry must
 * not be able to leave the number wrong. This is what tells an operator when a
 * drain has actually reached zero.
 */
export const MaintenanceStatusResSchema = Type.Object({
    state: Type.Enum(MaintenanceState),
    until: Type.Union([Type.String(), Type.Null()]),
    live_rooms: Type.Integer(),
    live_games: Type.Integer(),
});
